module.exports = __webpack_public_path__ + "static/media/vostok.35c0b3e1.jpg";